"use client";

import { useForm } from "@mantine/form";
import { Button, PasswordInput, TextInput } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { login } from "supabase/auth";
import { get_my_claims, supabaseClient } from "supabase";

type AuthFormProps = {
  onLoginSuccess: () => void;
};

export default function AuthForm(props: AuthFormProps) {
  const { onLoginSuccess } = props;

  const [loading, loadingHandler] = useDisclosure(false);

  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },

    validate: {
      email: (value:string) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      password: (value:string) => (value.length > 6 ? null : "Password is too short"),
    },
  });

  const makeSignin = (values: { email: string; password: string }) => {
    loadingHandler.open();
    login(values.email, values.password).then(async (res) => {
      loadingHandler.close();
      if (res.error !== null) {
        form.setFieldError("email", res.error.message);
      } else {
        const claims = await get_my_claims();

        if (!claims.data.claims_admin) {
          // Check if the user owns an organization
          const user = await supabaseClient
            .from("users")
            .select("*")
            .eq("auth_uid", res.data.user?.id!)
            .single();
          if (user.data.organization_id === null) {
            // Reject the login for non-admin users
            form.setFieldError("email", "Wrong email or password");
          } else {
            onLoginSuccess();
          }
        } else {
          onLoginSuccess();
        }
      }
    });
  };

  return (
    <form onSubmit={form.onSubmit(makeSignin)}>
      <TextInput
        {...form.getInputProps("email")}
        placeholder="Email"
        label="Email"
      />
      <PasswordInput
        mt="md"
        {...form.getInputProps("password")}
        placeholder="Password"
        label="password"
      />
      <Button mt="md" type="submit" loading={loading}>
        Submit
      </Button>
    </form>
  );
}
